import { inject, observer } from 'mobx-react'
import styled from 'styled-components'

import Message from './Message'

const MainLayout = (props) => {
  const { children } = props

  const language = props.language.toJS().selected
  const fontFamily = language === 'en' ? 'Inter' : 'NotoSansThai'

  return (
    <Layout fontFamily={fontFamily}>
      <Message />
      <Wrapper>
        <Body>{children}</Body>
      </Wrapper>
    </Layout>
  )
}

const Layout = styled.div`
  width: 100%;
  font-family: ${(props) =>
    props.fontFamily ? props.fontFamily : 'NotoSansThai'};
`

const Wrapper = styled.div`
  min-height: 100vh;
  max-width: 800px;
  margin: 0 auto;
`

const Body = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1440px;
  padding: 0px;

  @media print {
    min-height: 90vh;
    margin-top: 0px;
    padding: 0px;
  }
`

export default inject('language')(observer(MainLayout))
